import { STEP_INVITEE_PAGE, STEP_REFERRAL_DASHBOARD } from '../../router/router.constants';

export const TEXT_KEYS = {
    DASHBOARD_SOFT_CLOSING_TITLE: 'referrer_soft_closing_warning',
    INVITEE_SOFT_CLOSING_TITLE: 'invitee_soft_closing_warning'
};

export const TEXT_KEYS_BY_VIEW = {
    [STEP_REFERRAL_DASHBOARD]: TEXT_KEYS.DASHBOARD_SOFT_CLOSING_TITLE,
    [STEP_INVITEE_PAGE]: TEXT_KEYS.INVITEE_SOFT_CLOSING_TITLE
};
